/* eslint-disable import/prefer-default-export */
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_AUTH_TOKEN = process.env.REACT_APP_SENTRY_AUTH_TOKEN;
export const SENTRY_ORG = 'scalar-app';
export const SENTRY_PROJECT = 'frontend';
export const SENTRY_ENVIRONMENTS = ['production', 'staging'];

export const ABLY_AUTH_URL =
  process.env.REACT_APP_ABLY_AUTH_URL ?? `${process.env.REACT_APP_API_ENDPOINT}/api/ably-token`;

// PostHog product analytics & session replay
// POSTHOG_KEY is the project API key (phc_...) — a public, write-only token that is safe to expose in the client bundle.
// POSTHOG_HOST points at our reverse proxy (avoids ad-blockers stripping requests to posthog.com).
// POSTHOG_UI_HOST is the real PostHog app URL, used so generated links (e.g. toolbar) don't point at the proxy.
export const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
export const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST ?? 'https://hamm.scalar.io';
export const POSTHOG_UI_HOST = process.env.REACT_APP_POSTHOG_UI_HOST ?? 'https://us.posthog.com';

// Cloudflare Turnstile — empty site key disables client-side bot verification
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY ?? '';
export const TURNSTILE_SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

export const DECIMAL_PLACES = 15;
export const ONE_HUNDRED_VALUE = 100;
export const MAX_HISTORICAL_YEARS = 3;
export const WEIGHT_VALIDATION_FLOAT_TOLERANCE = 0.00001;
